<script setup>
import {useDate} from '@/composables/use-date.js'
import {dateFormats} from '@/constants/date-and-time.js'
import {toRefs} from 'vue'

//Props
const props = defineProps({
  date: {
    type: [Object, String],
    default: null,
  },
  emptyLabel: {
    type: String,
    default: '',
  },
})

//Composables
const {date} = toRefs(props)
const {formattedDate, relativeDate, isToday} = useDate(date, dateFormats.TIME)
</script>

<template>
  <span
    v-if="formattedDate"
    capitalise
  >{{ isToday ? formattedDate : relativeDate }}</span>
  <span v-else>{{ emptyLabel }}</span>
</template>
